export function dataUrlToFile(dataUrl: string, fileName: string): File {
  const [metadata, encoded] = dataUrl.split(',', 2);
  const mimeType = metadata?.match(/^data:([^;]+);base64$/i)?.[1] || 'image/png';
  if (!encoded || !metadata?.startsWith('data:')) throw new Error('Das geleerte Bild konnte nicht als Ausgangsbild übernommen werden.');
  const binary = atob(encoded);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return new File([bytes], fileName, { type: mimeType });
}

export async function fetchPrivateFile(fileId: string, fileName = 'property-partners-result.png'): Promise<File> {
  const response = await fetch(`/api/files/${encodeURIComponent(fileId)}`, { credentials: 'same-origin' });
  if (!response.ok) throw new Error('Die geschützte Rohdatei konnte nicht geladen werden.');
  const blob = await response.blob();
  if (!blob.size) throw new Error('Die geschützte Rohdatei ist leer.');
  return new File([blob], fileName, { type: blob.type || 'image/png' });
}

export async function fetchPrivateFileDataUrl(fileId: string, fileName = 'property-partners-result.png'): Promise<string> {
  return fileToDataUrl(await fetchPrivateFile(fileId, fileName));
}

export function fileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error('Die Bilddatei konnte nicht gelesen werden.'));
    reader.readAsDataURL(file);
  });
}
